// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-bar-clustered';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm10 16.5V19H3v-2.5h7Zm7-3.5v2.5H3V13h14ZM3 6.5h6V9H3V6.5ZM20 3v2.5H3V3h17Z' />
);

export const viewBox = '0 0 22 22';
